export const getRepairsStatusesConstants = {
  STATUSES_REPAIRS_REQUEST: "STATUSES_REPAIRS_REQUEST",
  STATUSES_REPAIRS_SUCCESS: "STATUSES_REPAIRS_SUCCESS",
  STATUSES_REPAIRS_FAILURE: "STATUSES_REPAIRS_FAILURE"
};
